import React from "react";
import PropTypes from "prop-types";
import { SVGICONS } from "config";
import { t } from "i18next";
import LanguageToggler from "features/LanguageToggler";

const AuthHeader = ({
  goBack,
  pageHeaderText = "Verification",
  hidePageHeaderText = false,
  description,
  title,
  blinkText,
  infoContent,
  buttonClass,
  buttonStyle,
  headerClass,
  headerStyle,
  titleClass,
  titleStyle,
  blinkClass,
  blinkStyle,
  descriptionClass,
  descriptionStyle,
  showInfoAlongWithDescription = false,
}) => {
  return (
    <React.Fragment>
      {/* Header */}
      <div className="my-1 py-5 flex items-center justify-between">
        <button onClick={goBack} className={buttonClass} style={buttonStyle}>
          <SVGICONS.BackArrow />
        </button>
        {!hidePageHeaderText && (
          <h4
            className={`flex-1 text-center text-20x font-bold text-shadow-forge-900 ${
              headerClass || ""
            }`}
            style={headerStyle}
          >
            {t(pageHeaderText)}
          </h4>
        )}
        {/* <div className="w-10"/> */}
        <div className="drop-shadow-md">
          <LanguageToggler />
        </div>
      </div>

      {/* Title */}
      {(title || blinkText) && (
        <h2
          className={`my-1 py-5 text-28x font-bold leading-32x ${
            titleClass || ""
          }`}
          style={titleStyle}
        >
          {title && <span className="text-shadow-forge-800">{t(title)}</span>}
          {blinkText && (
            <span
              className={`blinking-login-header px-2 text-brand-base-primary ${
                blinkClass || ""
              }`}
              style={blinkStyle}
            >
              {t(blinkText)}
            </span>
          )}
        </h2>
      )}

      {/* Description */}
      {description && (
        <p
          className={`text-16x leading-19x text-shadow-forge-700 ${
            descriptionClass || ""
          }`}
          style={descriptionStyle}
        >
          {t(description)}
          {showInfoAlongWithDescription && infoContent && infoContent}
        </p>
      )}
      {infoContent && !showInfoAlongWithDescription && infoContent}
    </React.Fragment>
  );
};

// PropTypes check
AuthHeader.propTypes = {
  goBack: PropTypes.func.isRequired,
  pageHeaderText: PropTypes.string,
  hidePageHeaderText: PropTypes.bool,
  description: PropTypes.string,
  title: PropTypes.string,
  blinkText: PropTypes.string,
  infoContent: PropTypes.element,
  buttonClass: PropTypes.string,
  buttonStyle: PropTypes.object,
  headerClass: PropTypes.string,
  headerStyle: PropTypes.object,
  titleClass: PropTypes.string,
  titleStyle: PropTypes.object,
  blinkClass: PropTypes.string,
  blinkStyle: PropTypes.object,
  descriptionClass: PropTypes.string,
  descriptionStyle: PropTypes.object,
};

export default AuthHeader;
